import React, {  useState, useEffect ,useRef} from 'react';
import axios from 'axios';
import Modal from "../Modalxl";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL,auTHURL,getUserId,getUser } from '../../utils/common';
import { useReactToPrint } from 'react-to-print';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const SubUserList = () => 
{
  const fileType ="xlsx";
  const tableRef = useRef(null);
  const API_URL = aPIURL();
  const AUTH_URL = auTHURL();
  const Parent_Id = getUserId();
  const Login_Name = getUser();
  
  const [actionId , setActionId]= useState('1');
  const [custType ,setCustType] = useState(1);
  const [cstatusId ,setCstatusId] = useState('0');
  const [custID, setCustID] = useState('0');
  const [stateId, setStateId]= useState( '');
  const [countryId, setCountryId]= useState('');                                
  const [custGST ,setCustGST]= useState("");   
  const [dActionname, setDActionname]= useState('Save');
  const [cDisplay, setCDisplay]= useState('none');
  const [cNameLevel, setCNameLevel]= useState('Name');           
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData]= useState([]);
  
  const [post, setPost] = useState([]);
  const [order, setOrder] = useState("ASC");
  const [number, setNumber] = useState(1); // No of pages
  const [postPerPage] = useState(10);
  const [inputs, setInputs] = useState({});

  const [StatusData, setStatusData]= useState([]);
  const [customerData, setCustomerData]= useState([]);
  const [filteredCustomerDetails,setFilteredCustomerDetails]= useState([]);
  const [allotedDeviceByCustID, setAllotedDeviceByCustID]= useState([]);
  const [showAddDetails, setShowAddDetails]= useState(false);
  const [showDetails, setShowDetails]= useState(false);
  const [changePass, setChangePass]= useState(false);
  const [redioDispl, setRedioDispl]= useState(false);
  const [resetPassword,setResetPassword]  = useState('none');
  let [custTypeId, setCustTypeId]= useState(0);
  let [currentUser,setCurrentUser] = useState(0);
  let [userMax,setUserMax] = useState(0);


  useEffect(() => {
       
    const curls=API_URL+'countries';
    
    axios.post(curls).then(response => {                            
    setCountryData(response.data.data)
     }).catch(function(error){console.log(error.message);});
        
     const surls=API_URL+`states?Country_ID=1`;
     axios.post(surls).then(response => {                            
      setStateData(response.data.data)
       }).catch(function(error){console.log(error.message);});
    
    //grid binding start 
    FillGrid(0);

  }, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);
 

const FillGrid=(Type_ID)=>
{   
    const curls=API_URL+`GpsCustomerAllChildList/?TypeID=${Type_ID}&ParentID=${Parent_Id}`;  
    //alert(curls);
    axios.post(curls).then(response => {  
    console.log(response.data.data);                           
    setPost(response.data.data);
     }).catch(function(error){console.log(error.message);});   
    
}
const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);
  };
              
  const showAddCustomerDetails=()=>
  {
         const sucurls=API_URL+`subusercount?Parent_ID=${Parent_Id}`;
         //alert(sucurls);
     
        axios.get(sucurls).then(response => 
        {
            setCurrentUser(response.data.data[0].currentUser);
            setUserMax(response.data.data[0].userMax);   
            if(response.data.data[0].currentUser<response.data.data[0].userMax)
             {  
                    setShowAddDetails(true);
                    setShowDetails(false);  
                    setInputs({});  
                    setStateId('');
                    setCountryId('');  
                    setChangePass(false);
                    setResetPassword('none');
                    let msgg= `Your maximum user limit is  ${response.data.data[0].userMax}`;
                    toast.success(msgg);  
             } 
             else
             {      
                        let msgg= `Sorry' You have reached your user limit, You can either purchase new device or contact to support team.`;
                        toast.error(msgg);  
             }                                   
        }
        ).catch(function (error) {          
            console.log(error.message);        
        });           
  } 

  const closeAddCustomerModal = () => 
  {
       setActionId('1'); 
       setDActionname('Save');
       setShowAddDetails(false);
       setShowDetails(false);  
       bindCustomerDetails();
       setInputs({});  
       setChangePass(false);
     
 }  

  const showDetailsModal = (index) => {          
    const d_Id = index;       
    const updatedCustomerList = post.filter((custElem) => {          
    
    return custElem.accountID === d_Id;

  });
   
    setFilteredCustomerDetails(updatedCustomerList);   
     
     bindAllottedDevice(d_Id);                
     setShowDetails(true);  
     setShowAddDetails(false);

}
const closeModal = () => {
     setShowDetails(false);
     setShowAddDetails(false); 
      
}
const sorting=(col)=>
{

  try
  {
    if(order==="ASC")
    {
            const sorted=[...post].sort((a,b)=>
            a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("DSC");
    }
    if(order==="DSC")
    {
            const sorted=[...post].sort((a,b)=>
            a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("ASC");
    }
  }
  catch(error) 
  {
    console.log(error.message);
  }  
          
}
const bindCustomerDetails=()=>
{
      //grid binding start 
        FillGrid(custTypeId);
       //grid binding end       
}

const bindAllottedDevice=(ca_Id)=>
{
    setAllotedDeviceByCustID([]);
    const adurls = API_URL+`AllotmentDeviceList/?AccountID=${ca_Id}`;    
    axios.get(adurls).then(response => {                         
        setAllotedDeviceByCustID(response.data.data);
    }).catch(function(error) {  console.log(error.message); });
}

const handleEdit=(index) => {
          
  const C_Id = index;  
                      
  const urls=API_URL+`GetGPSCustomerDetails/${C_Id}/`;
     
  axios.post(urls).then(response => 
  {
      setActionId('2'); 
      setDActionname('Update');
      setCustID(response.data.data[0].accountID);  
      setCountryId(response.data.data[0].countryID); 
      setStateId(response.data.data[0].stateID);    
      setChangePass(true); 
      setResetPassword('block');   
      setCustType(response.data.data[0].customerTypeID); 
      setCustGST(response.data.data[0].gstNumber);  
      setRedioDispl(true);
      if(response.data.data[0].customerTypeID ==1)
      {
            setCDisplay('none');
            setCNameLevel('Name');

      }
      else
      {
             setCDisplay('block');
             setCNameLevel('Company Name');
      }
      
           inputs.CustName=response.data.data[0].fullName;
           inputs.CustMobile= response.data.data[0].mobileNo;
           inputs.CustEmail= response.data.data[0].email;
           inputs.CustCompany= response.data.data[0].company;
           inputs.CustCity= response.data.data[0].city;
           inputs.CustPinCode= response.data.data[0].pinCode;
           inputs.CustUserName= response.data.data[0].userName;
           inputs.CustPassword= "Avaal@123";
           inputs.CustAddress= response.data.data[0].address; 
           inputs.CustCompanyWebsite= response.data.data[0].website;
           inputs.ContactPerson= response.data.data[0].contactName; 
           inputs.ContactNumber= response.data.data[0].contactPhone; 
           inputs.ContactEmail= response.data.data[0].contactEmail;    
           inputs.GSTNumber= response.data.data[0].gstNumber;           
                                                             
  }
  ).catch(function (error) {
     
    console.log(error.message);
        
 });   
        setShowAddDetails(true);
        setShowDetails(false);   
              
}

const setCustomerType=(event) =>
{
     if(event.target.value==1)
     {
           setCustType(1);           
           setCDisplay('none');
           setCNameLevel('Name');
     }
     else
     {
           setCustType(2);            
           setCDisplay('block');
           setCNameLevel('Company Name');
     }
       
     
}
const ChangeStateD = (e) => {

    setStateId(e.target.value);   

}
const ChangeCountryD = (e) => {

    setCountryId(e.target.value);
}

const changeHandler = (event) => {
if(event.target.name==='CustMobile')
  {
        const re = /^[0-9\b]+$/;
        if (event.target.value === '' || re.test(event.target.value)) 
        {
         
              const name = event.target.name;
             //alert(name);
             const value = event.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['CustMobile']: ""}))
              
        }
        
  }
  else if(event.target.name==='CustPinCode')
  {
        const re1 = /^[0-9\b]+$/;
        if (event.target.value === '' || re1.test(event.target.value)) 
        {
              const name = event.target.name;
             //alert(name);
             const value = event.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['CustPinCode']: ""}))
           
        }
        
  }
  else if(event.target.name==='ContactNumber')
  {
        const re2 = /^[0-9\b]+$/;
        if (event.target.value === '' || re2.test(event.target.value)) 
        {
              const name = event.target.name;
             //alert(name);
             const value = event.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['ContactNumber']: ""}))
        }
        
  }
  else
  {
      const name = event.target.name;
      //alert(name);
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
  }
}

const onClickRegister = () => {
  
    
  if(!inputs.CustName && custType===1)  
  {
    
    toast.error("Name is required.");
    return;
   }
  else if(inputs.CustName===''  && custType===1)
  {
    toast.error("Name is required.");
     return;
  }
  if(!inputs.CustName && custType===2)  
  {
    toast.error("Company name is required.");
    return;
   }
  else if(inputs.CustName===''  && custType===2)
  {
    toast.error("Company name is required.");
     return;
  }
  else if(!inputs.CustMobile)
  {
    toast.error("Customer mobile number is required.");
    return;
  }
  else if(inputs.CustMobile==='')
  {
    toast.error("Customer mobile number is required.");
    return;
  }
  else if(inputs.CustMobile.length<10 || inputs.CustMobile.length>10)
  {
    toast.error("Customer mobile number should be 10 digits.");
    return;
  }
  else if(!inputs.CustEmail)
  {
       toast.error("Customer email is required.");
       return;
  }
  else if(inputs.CustEmail==='')
  {
       toast.error("Customer email is required.");
       return;
  }
  else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(inputs.CustEmail))
  {
       toast.error("Customer email is invalid.");
       return;
  }  
  
  else if(!countryId)
  {
        toast.error("Country is required.");
        return;
  }
  else if(countryId==='')
  {
         toast.error("Country is required.");
         return;
  }
  else if(!stateId)
  {
         toast.error("State is required.");
         return;
  }
  else if(stateId==='')
  {
         toast.error("State is required.");
         return;
  }
  else if(!inputs.CustCity)
  {
       toast.error("City name is required.");
       return;
  }
  else if(inputs.CustCity==='')
  {
        toast.error("City name is required.");
        return;
  }
  else if(!inputs.CustPinCode)
  {
        toast.error("Pincode is required.");
       
       return;
  }
  else if(inputs.CustPinCode==='')
  {
        toast.error("Pincode is required.");
        return;
  }
  else if(!inputs.CustUserName)
  {
        toast.error("Username is required.");
        return;
  }
  else if(inputs.CustUserName==='')
  {
        toast.error("Username is required.");
        return;
  }
  else if(inputs.CustPassword==='')
  {
        toast.error("Password is required.");
        return;
  }
  else if(!inputs.CustPassword)
  {
       toast.error("Password is required.");             
       return;
  }
//Password validation starts
if (inputs.CustPassword.length < 8) {
  toast.error('Invalid password, password must contain greater than or equal to 8 characters.')
  return
}

let countUpperCase = 0
let countLowerCase = 0
let countDigit = 0
let countSpecialCharacters = 0
let password = inputs.CustPassword;
for (let i = 0; i < password.length; i++) {
  const specialChars = [
    '!', '@','#','$','%','^','&','*','(',')','_','-','+','=','[','{',']','}',':',';','<','>', ]

  if (specialChars.includes(password[i])) {
        countSpecialCharacters++
  } else if (!isNaN(password[i] * 1)) {
        countDigit++
  } else {
    if (password[i] == password[i].toUpperCase()) {
          countUpperCase++
    }
    if (password[i] == password[i].toLowerCase()) {
         countLowerCase++
    }
  }
}

if (countLowerCase == 0) {
  toast.error('Invalid password, no lower case characters in password')
  return
}

if (countUpperCase == 0) {
  toast.error('Invalid password, no upper case characters in password')
  return
}

if (countDigit == 0) {
  toast.error('Invalid password, no digit characters in password')
  return
}

if (countSpecialCharacters == 0) {
  toast.error('Invalid password, no special characters in password')
  return
}
//Password validation ends
else  
{
 if(actionId==='1')
 {
   
 //Check UserMax and CurrUser   
 if(currentUser>userMax || currentUser==userMax)
 {  
   toast.error("Sorry' You have reached your user limit, You can either purchase new device or contact to support team.");  
   return
 }
  //Insert User Details
const userparams = JSON.stringify(
{         
    "Name": inputs.CustName,
    "Username": inputs.CustUserName,
    "Email": inputs.CustEmail,
    "PhoneNumber":inputs.CustMobile,
    "Password":inputs.CustPassword,
    "ConfirmPassword":inputs.CustPassword,
    "Role":"Customer",
    "createdBy": Login_Name,
    "ParentID": Parent_Id            
});
      
 //Insert Customer Details
 const params = JSON.stringify(
 {
       "accountID": 0,
        "company": inputs.CustName,
        "gstNumber": inputs.GSTNumber, 
        "contactName": inputs.ContactPerson,
        "contactPhone": inputs.ContactNumber,
        "contactEmail": inputs.ContactEmail,
        "website": inputs.CustCompanyWebsite,
        "customerTypeID": custType,
        "fullName": inputs.CustName,
        "userName": inputs.CustUserName,
        "address": inputs.CustAddress,
        "city": inputs.CustCity,
        "pinCode": inputs.CustPinCode,
        "is_Active": 1,
        "countryID": countryId,
        "stateID": stateId,
        "mobileNo": inputs.CustMobile,
        "email": inputs.CustEmail,
        "createdBy": Login_Name,
        "ParentID": Parent_Id      
     
 });
    
    //User Registration start
   
    axios.post(AUTH_URL+'Register', userparams, {            
    "headers": 
    {
         "content-type": "application/json",   
    },
    })
    .then(function (response) 
    {
        console.log(response.data);

         if(response.data.statusCode === 200 && response.data.validStatus === true)     //if(response.data.statusCode === 1) 
         {
                  //customer registration start
                  axios.post(API_URL+'GPSCustomerInsert', params, {

                   "headers": 
                    {
                        "content-type": "application/json",    
                    },
                    })
                    .then(function (response) 
                    {
                            if(!response.data.validStatus)
                            {
                                  //alert("customer saved");
                                  toast.error(response.data.message);
                                  //return;                                       
                            }
                            else
                            {
                                  // alert(response.data.message);
                                  toast.success(response.data.message);
                                  //console.log("---------------------save--------------------------");
                                  handleAddCustomerClear();                                
                          }      
                    })
                    .catch(function (error) 
                    {
                          toast.error("Some Error occured while saving customer record,Please Provide Valid Inputs.");                  
                          console.log(error.message);    
                    });
                    console.log("---------------------end saved------------------------");                      
          } 
          else
          {
                    toast.error(response.data.message);
          }               
   
    })
    .catch(function (error) 
    {
       
       //toast.error("Some Error occured while saving User record, Please Provide Valid Input.");
                    
        console.log(error);    
    });
    //user Registration ends
        
     
  } 
  else
  {
       //Update Device Details
     const params = JSON.stringify({
                 
    "accountID": custID,
    "company": inputs.CustName,
    "gstNumber": inputs.GSTNumber, 
    "contactName": inputs.ContactPerson,
    "contactPhone": inputs.ContactNumber,
    "contactEmail": inputs.ContactEmail,
    "website": inputs.CustCompanyWebsite,
    "customerTypeID": custType,
    "fullName": inputs.CustName,
    "userName": inputs.CustUserName,
    "address": inputs.CustAddress,
    "city": inputs.CustCity,
    "pinCode": inputs.CustPinCode,
    "is_Active": 1,
    "countryID": countryId,
    "stateID": stateId,
    "mobileNo": inputs.CustMobile,
    "email": inputs.CustEmail,
    "createdBy": Login_Name,
    "ParentID": Parent_Id        
    });

     axios.post(API_URL +'GpsCustomersEdit', params, {

         "headers": 
         {
                "content-type": "application/json",    
         },

    })
      .then(function (response) 
      {
        if(!response.data.validStatus)
        {
                 toast.error(response.data.message);
                 //return;
        }
        else
        {
              
              toast.success(response.data.message);
              console.log(response.data);
        }                       
           
      })

      .catch(function (error) 
      {
            
            toast.error("Some Error occured while saving customer record, Please Provide valid Inputs");
            console.log(error);    
      });
        //console.log(this.state);
        handleUpdateCustomerClear();            
            
  }   
}
}

const handleAddCustomerClear=()=>
  {

     setInputs({});
     setCustID('0'); 
     setActionId('1'); 
     setDActionname('Save');
     setStateId(''); 
     setCountryId('');              
     setCustomerData([]); 
     setChangePass(false);         
     //bind device details grid
     bindCustomerDetails();    
     
  }
  const handleUpdateCustomerClear=()=>
  {
       //bind device details grid
       bindCustomerDetails(); 
       
  }
  
  const exportStatus = e => {
    const value = e.target.value;
    setCustTypeId(e.target.value);
    //alert(value)
    FillGrid(value);
  }
  const exportToCSV=()=>
    {
      const newPost = post.map(({ accountID,cAddress,status,pincode, ...rest }) => rest);
       const ws= XLSX.utils.json_to_sheet(newPost);        
       var wscols = [
          {wch:5} ,
          {wch:30},
          {wch:30},
          {wch:20},
          {wch:30},
          {wch:30},
          {wch:20},    
          {wch:20},
          {wch:20}
      ];
   
      var wsrows = [
         {hpx: 30}
      ];
      
      ws['!cols'] = wscols;
      ws['!rows']=wsrows;
           
      let Heading = [['S.No.','Customer Name','Company Name','Mobile Number','Email','UserName','Country','State','City']];
      const wb={Sheets:{Customers:ws},SheetNames:["Customers"]};
      XLSX.utils.sheet_add_aoa(ws, Heading);     
      const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
      const data= new Blob([excelBuffer],{type:fileType});
      FileSaver.saveAs(data,"AvtCustomerReport"+".xlsx");
     }

  const exportDownload = e => 
  {  
  
  const value = e.target.value; 
  //alert(value)
  
  if(value=="Excel")
  {
         exportToCSV();  
       //onDownload();
  }
  if(value=="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
  }
  /*const { onDownload } = useDownloadExcel({
  currentTableRef: tableRef.current,
  filename: "CustomerDetails",
  sheet: "Customers"
  });*/
  const handlePrint = useReactToPrint({
  documentTitle: "Customer Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
  });
   
  return (
<>     

<Modal isOpen={showDetails} > 
      <div class="modal-header">
                <h5 className='modal-title'>User Details</h5>
                <button type="button" class="btn-close"  onClick={closeModal}></button>
                </div>
                <div class="modal-body">                        
                <div class="row">
                 <table >
                {filteredCustomerDetails.map(custdata1 => (                <tr key={custdata1.accountID}>
                    <td>                    
                    <div class="row">
                  
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;              
                    <b> Customer Name : </b>      
                    {custdata1.customerName}
                    </div>
                    
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> Mobile Number : </b>        
                    {custdata1.mobileNo}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> Email : </b>       
                    {custdata1.email}
                    </div>
               
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> Country : </b>        
                    {custdata1.countryName}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> State : </b>        
                    {custdata1.stateName}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b>City : </b>      
                    {custdata1.city}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> PinCode : </b>        
                    {custdata1.pincode}
                    </div>
                   
                               
                    </div>               
                    </td>                            
                </tr>
                 ))}
                </table>
                
                <table class="table table-striped table-bordered table-hover">
                    <thead> 
                    <tr>
                    <th>Sell Date</th> 
                    <th> Sold To</th>   
                    <th>Device Name</th>
                    <th>IMEI Number</th>            
                    <th>Subscribtion Type</th>                     
                    </tr>
                    </thead>
                     <tbody>
               
                {allotedDeviceByCustID.map(devalldata => (
                <tr key={devalldata.allotmentID}>
                <td>{devalldata.allotmentDate}</td> 
                <td>{devalldata.allotyName}</td>
                <td>{devalldata.deviceName}</td>
                <td>{devalldata.imeiNumber}</td>                
                <td>{devalldata.subscribeName}</td>                       
                  
                </tr>
              )                   
              )
              }      
               </tbody>
               </table>   
                
              
              
                </div>
                </div>
</Modal>
  
<Modal isOpen={showAddDetails} >  
 <div class="modal-header">
 <h5 className='modal-title'>User Details</h5>
 <button type="button" id="closeAddCustomerModal" class="btn-close" onClick={closeAddCustomerModal}></button>
 </div>
 <div class="modal-body"> 
           
<div class="row">
<div class="col-sm-4 col-md-4 form-group" >
Name:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="CustName"  type="text" required="required"  className="form-control"  value={inputs.CustName} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Mobile Number:<span style={{color:"red"}}>&nbsp;*</span>
<input name="CustMobile" type="text" required="required" className="form-control" maxLength={10} value={inputs.CustMobile} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Email:<span style={{color:"red"}}>&nbsp;*</span>
<input name="CustEmail" type="text" required="required" className="form-control" value={inputs.CustEmail} onChange={changeHandler} ></input>
</div>        

<div class="col-sm-4 col-md-4 form-group">
Country:<span style={{color:"red"}}>&nbsp;*</span>
<select className="form-control" name="DCountry" value={countryId} onChange={ChangeCountryD}  >
      <option>Select Country</option>
        {countryData.map((e, key) => {
             return <option key={key} value={e.id}>{e.country_Name}</option>;
        })}
</select>
</div>
<div class="col-sm-4 col-md-4 form-group">
State:<span style={{color:"red"}}>&nbsp;*</span>
<select className="form-control slct" name="DState" value={stateId} onChange={ChangeStateD} >
     <option>Select State</option>
     {stateData.map((e, key) => {
     return <option key={key} value={e.id}>{e.state_Name}</option>;
     })}
</select>
</div>
<div class="col-sm-4 col-md-4 form-group">
City:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="CustCity"  type="text" required="required"  className="form-control"  value={inputs.CustCity} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
PinCode:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="CustPinCode"  type="text" required="required"  maxLength={6} className="form-control" value={inputs.CustPinCode} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Address
<textarea name="CustAddress" type="text" className="form-control" value={inputs.CustAddress} onChange={changeHandler} rows={2} cols={20} />
 </div> 
<span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px" }}><b>User/Login Details </b> </span> 
<div class="col-sm-4 col-md-4 form-group">
User/Login Name:<span style={{color:"red"}}>&nbsp;*</span>        
 <input name="CustUserName"  type="text" required="required"  className="form-control" placeholder='User/Login Name Used for login' disabled={changePass} value={inputs.CustUserName} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Password:<span style={{color:"red"}}>&nbsp;*</span>        
 <input name="CustPassword"  type="password" required="required" placeholder='Min 8 characters, at least 1 uppercase letter, 1 lowercase letter and 1 number' disabled={changePass} className="form-control" value={inputs.CustPassword} onChange={changeHandler} ></input>
</div>	
<div class="col-sm-4 col-md-4 form-group" style={{marginTop: "27px"}}>

</div>
<div class="col-sm-12 col-md-12 form-group">
 <center>
 <button type="submit" id="Save" onClick={onClickRegister} className="btn btn-primary2">{dActionname} </button>     
 </center>
 </div></div></div>
 </Modal>
 
 <div className="top-bar clearfix">
  <div className="row">
  <div className="col-md-4">
   <h2> Users  </h2>             
   </div>
   <div className="col-md-8 text-right">
          <button type="submit" id="showAddCustomerDetails" onClick={() => showAddCustomerDetails()} className="btn btn-new"> New </button>                    
            <select onChange={exportStatus} className="btn btn-primary" name="Export">
            <option value={"0"}>All</option>    
            <option value={"1"}>Enabled</option>  
            <option value={"2"}>Disabled</option>                
            </select>
            <select onChange={exportDownload} name="DGroup" className="btn btn-primary"  >
            <option value={"Download"}>Download</option>    
            <option value={"Excel"}>Excel</option>    
            <option value={"PDF"}>PDF</option>                      
            </select>
          </div>
        </div>
      </div>
    
      <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div class="card-body p-0">
       <table ref={tableRef} id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
       <thead>
            <tr>    
               <th style={{textAlign:"center"}}>S.No. </th>            
                <th onClick={()=>sorting("customerName") } style={{textAlign:"center","cursor": "pointer"}}>Customer Name &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th onClick={()=>sorting("mobileNo") } style={{textAlign:"center","cursor": "pointer"}}>Mobile Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i> </th>
                <th onClick={()=>sorting("email") } style={{textAlign:"center","cursor": "pointer"}}>Email &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th onClick={()=>sorting("countryName") } style={{textAlign:"center","cursor": "pointer"}}>Country &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i> </th>
                <th onClick={()=>sorting("stateName") } style={{textAlign:"center","cursor": "pointer"}}>State &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th onClick={()=>sorting("city") } style={{textAlign:"center","cursor": "pointer"}}>City &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th onClick={()=>sorting("pincode") } style={{textAlign:"center","cursor": "pointer"}}>PinCode &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th onClick={()=>sorting("userName") } style={{textAlign:"center","cursor": "pointer"}}>UserName &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>                
                <th onClick={()=>sorting("accountID") } style={{textAlign:"center"}}>Action </th>
            </tr>
       </thead>
       <tbody>
       {currentPost.map((custdata) => {
            return (
                  
              <tr key={custdata.id}>
              <td style={{textAlign:"center"}}>{custdata.id}</td>       
              <td>{custdata.customerName}</td>
              <td style={{textAlign:"center"}}>{custdata.mobileNo}</td>
              <td>{custdata.email}</td>
              <td>{custdata.countryName}</td>
              <td>{custdata.stateName}</td>
              <td>{custdata.city}</td>
              <td style={{textAlign:"center"}}>{custdata.pincode}</td>
              <td>{custdata.userName}</td>
              <td style={{textAlign:"center", fontSize:"16px"}}>
             {/* <i onClick={() => showDetailsModal(custdata.accountID)} style={{ color:"green", cursor:'pointer'}} className="fa-solid fa-list" title="View Details"></i>
              &nbsp;&nbsp; */}
              <i onClick={() => handleEdit(custdata.accountID)} style={{ color:"#fd0691", cursor:'pointer'}} className="fa-solid fa-pen-to-square" title="View/Update Details"></i>
              </td>
              </tr>
           
            );
          })}          
            </tbody>
            </table>    
            <ReactPaginate  previousLabel={"<<"}  nextLabel={">>"}  pageCount={PageCount}  onPageChange={ChangePage}     
            disableInitialCallback={true}  initialPage={0} containerClassName={'pagination justify-content-end'} pageClassName={'page-item'}
            pageLinkClassName={'page-link'}  previousClassName={'page-item'} previousLinkClassName={'page-link'} nextClassName={'page-item'}
            nextLinkClassName={'page-link'}  breakClassName={'page-item'} breakLinkClassName={'page-link'} activeClassName={'active'}></ReactPaginate>       
            </div> </div></div>    
            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>    
    </>
    );
    }

export default SubUserList;
